import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.RiskRefreshListEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.RiskRefreshListRedirect })));

export default { edit, list };
